/**
 * Created by Joe on 2017/7/19.
 */
import axios from 'axios'

let base = 'http://api.gushuhua.org'

export const postKeyword = keyword => {
  return axios.post(`${base}/v1/queryKeyword/keyword/${keyword}`).then(res => res.data)
}

export const postVisitedGSH = (md5, name, author) => {
  return axios.post(`${base}/v1/visitedGSH/md5/${md5}/name/${name}/author/${author}`).then(res => res.data)
}

export const getMetaByKeyword = keyword => {
  return axios.get(`${base}/v1/GSH?keyword=${keyword}`).then(res => res.data)
}



// WEBPACK FOOTER //
// ./src/api/index.js